import {ModuleFc} from '@/project'
import {updateObject} from '@/store/utils'
import {WorkflowState, Workflow, LoadingWorkflowStatus, GetWorkflowStatusPayload} from './types'
import {delay} from '@/utils'

export {Workflow, WorkflowState}

const initState = {
  currentId: '',
  loadingWorkflowStatus: 'pending',
  set: {},
}

const module: ModuleFc<WorkflowState> = (ctx) => ({
  namespaced: true,
  state: {...initState},
  mutations: {
    set(state, payload: Workflow) {
      state.currentId = payload.id
      ctx.$set(state.set, payload.id, payload)
    },
    remove(state, id: string) {
      delete state.set[id]
    },
    setLoading(state, payload: LoadingWorkflowStatus) {
      state.loadingWorkflowStatus = payload
    },
    clear(state) {
      updateObject(state, initState)
    }
  },
  actions: {
    triggerWorkflow({commit, rootState}, code: string) {
      return ctx
        .$axios({
          url: `/bizs/${rootState.biz.id}/workflows/`,
          method: 'post',
          data: {code},
        })
        .then((resp) => {
          commit('set', resp.data)
          return resp.data
        })
    },
    monitorWorkflow: function * ({rootState}, id: string) {
      /*
      워크플로우의 진행상황을 모니터링 하기위한 action

      ### Code Example
        this.monitorWorkflow('be3cfb46-0772-479f-82fe-e5f17dd0c7d5')
          .then(async (iter) => {
            let curr = iter.next()
            while(!curr.done) {
              curr.value
                .then((resp) => {
                  console.log('refresh.resp:', resp)
                })
              curr = iter.next()
              await delay(1000)
            }
          })
       */
      let isFinished: boolean = false
      while(!isFinished) {
        yield ctx.$axios({
          url: `/bizs/${rootState.biz.id}/workflows/${id}`
        })
          .then((resp) => {
            const workflow = resp.data
            isFinished = workflow.isFinished || workflow.isCanceled
            return workflow
          })
          .catch((err) => {
            isFinished = true
            throw new Error(err)
          })
      }
    },

    getWorkflowStatus({dispatch, commit}, payload: GetWorkflowStatusPayload) {
      commit('setLoading', 'loading')
      let requestTime = 0
      const timer = setInterval(() => {
        requestTime += 1
      }, 1000)

      const {
        id,
        delayTimeCondition = () => 2000,
        afterNextCb = () => ({}),
      } = payload

      const requestDelayTime = (time) => delayTimeCondition(time)
      const afterNextFunc = (resp, time) => afterNextCb(resp, time)

      return new Promise((resolve, reject) => {
        dispatch('monitorWorkflow', id)
          .then(async (iter) => {
            let curr = iter.next()
            while(!curr.done) {
              curr.value
                .then((resp) => {
                  commit('set', {...resp, ...payload})
                  const {isFinished, progressValue, isCanceled} = resp
                  const percentage = progressValue < 10 ? 10 : progressValue
                  commit('layout/setProgress', percentage, {root: true})
                  if(isFinished || isCanceled) {
                    commit('layout/setProgress', 0, {root: true})
                    commit('setLoading', 'completed')
                    clearInterval(timer)
                    requestTime = 0
                    resolve(resp)
                  }
                  afterNextFunc(resp, requestTime)
                })
                .catch((err) => {
                  commit('setLoading', 'pending')
                  clearInterval(timer)
                  reject(err)
                })
              await delay(requestDelayTime(requestTime))
              curr = iter.next()
            }
          })
      })
    },
    cancelWorkflow({rootState}, workflowId) {
      return ctx
        .$axios({
          url: `/bizs/${rootState.biz.id}/workflows/${workflowId}`,
          method: 'delete',
        })
        .then((resp) => {
          return resp
        })
    },
  }
})

export default module
